import { useCallback } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import { getNumComparators } from "../../../library/comparators";
export const CustomPrefixFilter = (props) => {
  const { model, onModelChange, colDef } = props;
  const prefix = colDef.filterParams.prefix || "";
  const filterOptions = getNumComparators();

  const valueChanged = useCallback((event) => {
    if(event.target.value === "" || isNaN(event.target.value)) {
      onModelChange(null);
      return;
    }
    const newValue = Math.max(0, parseInt(event.target.value) || 0);;
    
    const currentFilterType = model?.type || ":";
    onModelChange(newValue === "" ? null : { filter: newValue, type: currentFilterType });
  }, [onModelChange]);

  const filterChanged = useCallback((event) => {
    
    const newFilterType = event.target.value;
    const currentFilterValue = model?.filter || "";
    onModelChange(currentFilterValue === "" ? null : { filter: currentFilterValue, type: newFilterType });
  }, [onModelChange, model]);
  const clearFilter = useCallback(() => {
    onModelChange(null);
  }, [onModelChange]);

  return (
    
    <div className="state-filter">
            <Form>
                <Form.Select size="sm" value={model?.filter ?? ''} onChange={filterChanged}>
                    {
                        filterOptions.map((option, index) => (
                            <option key={index} value={option.displayKey}>{(option.displayName)}</option>
                        ))
                    }
                </Form.Select>
                <div className="id-filter">
                    <span>{prefix}</span>
                    <Form.Control
                        size="sm"
                        type="number"
                        min={0}
                        value={model?.filter ?? ""}
                        onChange={valueChanged}
                        onKeyDown={typeof setting === 'number' ? (e) => {
                            if (e.key === 'e' || e.key === 'E' || e.key === '.' || e.key === ',') {
                                e.preventDefault();;
                            }
                        } : undefined}
                        placeholder="Job Id..."
                    />
                </div>
            <div className="d-flex justify-content-end mt-2 mb-2">
                <Button className="ag-button ag-standard-button ag-filter-apply-panel-button" value="" size="sm" onClick={valueChanged}>Reset</Button>
            </div>
             
            </Form>
        </div>
  );
};
